import {observer} from 'mobx-react';
import RadioButtonGroup from '../../../../../../components/radio-button-group';
import {useContext} from 'react';
import FilterStepsContext from '../../../../../../components/filter-steps/libs/context';
import {checkModuleAccess, PermissionModule} from '../../../../../../lib/check-module-access';
import checkAccess, {SiteFeature} from '../../../../../../lib/check-access';

const viewValues = [
    {name: 'Pricing Relativities', value: 'relativity'},
    {name: 'Code Level Detail', value: 'detail'}
];

const dataViewValues = [
    {name: 'Hospital', value: 'hospital'},
    {name: 'Payer', value: 'payer'}
];

const envValues = [
    {name: 'Production', value: 'production'},
    {name: 'UAT', value: 'uat'}
];

const DataSelectionFilterStep = observer(() => {
    const filterStepsStore = useContext(FilterStepsContext);

    function disableReportedBy() {
        return !checkModuleAccess(PermissionModule.PTPayer) || !checkModuleAccess(PermissionModule.PTHospital);
    }

    return <div className="pb-5">
        <div className="w-1/2 flex justify-between">
            <div>
                <label>Reported By</label>
                <RadioButtonGroup disabled={disableReportedBy()} className="flex flex-col space-y-1 mt-1" values={dataViewValues} value={filterStepsStore.dataView} onChange={dataView => filterStepsStore.dataView = dataView} />
            </div>
            <div>
                <label>Dataset Type</label>
                <RadioButtonGroup className="flex flex-col space-y-1 mt-1" values={viewValues} value={filterStepsStore.view} onChange={view => filterStepsStore.view = view} />
            </div>
            {checkAccess(SiteFeature.ptEnv) && <div>
                <label>Environment</label>
                <RadioButtonGroup className="flex flex-col space-y-1 mt-1" values={envValues} value={filterStepsStore.useUATEnvironment ? 'uat' : 'production'} onChange={env => filterStepsStore.useUATEnvironment = env === 'uat'} />
            </div>}
        </div>
    </div>;
});

export default DataSelectionFilterStep;